import PropTypes from "prop-types"
import { connect } from "react-redux"

import { cn } from "styles/utils"

const Key = ({ backspace, className = "", keyboard = "", ...props }) => (
  <button
    className={cn(
      "bg-neutral active:bg-primary w-(--base-width) tablet:w-(--tablet-width) mr-5 cursor-pointer rounded-sm border px-6 py-1 text-white last:mr-0 active:outline-none",
      backspace ? "text-32" : "text-28",
      keyboard === "arabic" &&
        ` ${backspace ? "text-20 tablet:text-32" : "text-16 tablet:text-28"} tablet:mr-3 mr-1`,
      className
    )}
    style={{
      "--base-width":
        keyboard === "arabic"
          ? backspace
            ? "42px"
            : "28px"
          : backspace
            ? "64px"
            : "44px",
      "--tablet-width":
        keyboard === "arabic"
          ? backspace
            ? "62px"
            : "42px"
          : "var(--base-width)",
      borderColor: "#191919",
      height: "51px",
    }}
    {...props}
  />
)
Key.propTypes = {
  backspace: PropTypes.bool,
  className: PropTypes.string,
  keyboard: PropTypes.string,
}

const keyboards = {
  arabic: [
    ["backspace", "اَ", "أ", "آ", "إ", "اِ", "أو", "او", "اُ", "ژ"],
    ["ض", "ص", "ث", "ق", "ف", "غ", "ع", "ه", "خ", "ح", "ج", "چ"],
    ["ش", "س", "ی", "ب", "ل", "ا", "ت", "ن", "م", "ك", "ک", "گ"],
    ["ظ", "ط", "ز", "ر", "ذ", "د", "پ", "و", "ي"],
  ],
  hebrew: [
    ["backspace", "ק", "ר", "א", "ט", "ו", "ן", "ם", "פ"],
    ["ש", "ד", "ג", "כ", "ע", "י", "ח", "ל", "ך", "ף"],
    ["ז", "ס", "ב", "ה", "נ", "מ", "צ", "ת", "ץ"],
  ],
}

const InternalKeyboard = ({ type, engraving, currentText, setEngraving }) => {
  if (!engraving) {
    return null
  }

  return (
    <div className="mt-25 flex flex-col">
      {keyboards[type].map((row, i) => (
        <div className="mb-5 flex justify-center" key={"row" + i}>
          {row.map((k, ki) => (
            <Key
              backspace={k === "backspace"}
              key={"key" + ki}
              keyboard={type}
              onClick={() => setEngraving(engraving, currentText, k)}
              type="button"
            >
              {k === "backspace" ? "➞" : k}
            </Key>
          ))}
        </div>
      ))}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentText:
      state.choices.e1 && !state.choices.e1.is_default
        ? state.choices.e1.value
        : "",
    engraving: state.wizard.data.e1,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setEngraving: (engraving, currentText, pressedKey) => {
      let newText = ""
      if (pressedKey === "backspace") {
        newText = currentText.substr(0, currentText.length - 1)
      } else if (ownProps.type == "arabic") {
        newText = pressedKey
      } else {
        newText = currentText + pressedKey
      }
      engraving.value = newText

      ownProps.enterInput(engraving, false, ownProps.setFastEngravingValue)
    },
  }
}

InternalKeyboard.propTypes = {
  currentText: PropTypes.string,
  engraving: PropTypes.object,
  setEngraving: PropTypes.func,
  type: PropTypes.string,
}

const Keyboard = connect(mapStateToProps, mapDispatchToProps)(InternalKeyboard)

export default Keyboard
